import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  class: "drp-presets",
  "aria-label": "Raccourcis"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "drp-main" }
const _hoisted_5 = {
  key: 0,
  class: "drp-type"
}
const _hoisted_6 = {
  class: "drp-type-list",
  role: "radiogroup",
  "aria-label": "Type de date"
}
const _hoisted_7 = ["aria-checked", "onClick"]
const _hoisted_8 = { class: "drp-inputs" }
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value", "min"]
const _hoisted_11 = { class: "drp-cals" }
const _hoisted_12 = { class: "drp-cal-head" }
const _hoisted_13 = {
  key: 1,
  class: "drp-nav-spacer"
}
const _hoisted_14 = {
  key: 3,
  class: "drp-nav-spacer"
}
const _hoisted_15 = {
  class: "drp-grid drp-weekdays",
  "aria-hidden": "true"
}
const _hoisted_16 = ["aria-label", "aria-pressed", "onClick", "onMouseenter"]
const _hoisted_17 = { class: "drp-foot" }
const _hoisted_18 = { class: "drp-summary" }
const _hoisted_19 = { class: "drp-days" }
const _hoisted_20 = { class: "drp-actions" }
const _hoisted_21 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "drp",
    role: "dialog",
    "aria-label": "Choisir une période",
    onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('close')), ["stop"]), ["esc"]))
  }, [
    _createElementVNode("aside", _hoisted_1, [
      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "drp-caption" }, "Raccourcis", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presets, (p) => {
        return (_openBlock(), _createElementBlock("button", {
          key: p.key,
          type: "button",
          class: _normalizeClass(["drp-preset", { active: _ctx.activePreset === p.key }]),
          onClick: ($event: any) => (_ctx.applyPreset(p.key))
        }, [
          _createElementVNode("span", null, _toDisplayString(p.label), 1),
          (p.hint)
            ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(p.hint), 1))
            : _createCommentVNode("", true)
        ], 10, _hoisted_2))
      }), 128))
    ]),
    _createElementVNode("section", _hoisted_4, [
      (_ctx.dateTypes.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "drp-caption" }, "Filtrer sur", -1)),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateTypes, (t) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: t.value,
                  type: "button",
                  role: "radio",
                  class: _normalizeClass(["drp-type-btn", { active: _ctx.draftType === t.value }]),
                  "aria-checked": _ctx.draftType === t.value,
                  onClick: ($event: any) => (_ctx.draftType = t.value)
                }, _toDisplayString(t.label), 11, _hoisted_7))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("label", {
          class: _normalizeClass(["drp-field", { focus: !_ctx.draftStart || (_ctx.draftStart && _ctx.draftEnd) }])
        }, [
          _cache[10] || (_cache[10] = _createElementVNode("span", null, "Du", -1)),
          _createElementVNode("input", {
            type: "date",
            value: _ctx.toInput(_ctx.draftStart),
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onInput('start', $event)))
          }, null, 40, _hoisted_9)
        ], 2),
        _cache[12] || (_cache[12] = _createElementVNode("i", {
          class: "ph ph-arrow-right drp-arrow",
          "aria-hidden": "true"
        }, null, -1)),
        _createElementVNode("label", {
          class: _normalizeClass(["drp-field", { focus: _ctx.draftStart && !_ctx.draftEnd }])
        }, [
          _cache[11] || (_cache[11] = _createElementVNode("span", null, "Au", -1)),
          _createElementVNode("input", {
            type: "date",
            value: _ctx.toInput(_ctx.draftEnd),
            min: _ctx.toInput(_ctx.draftStart),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onInput('end', $event)))
          }, null, 40, _hoisted_10)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (month, mi) => {
          return (_openBlock(), _createElementBlock("div", {
            key: month.key,
            class: "drp-cal"
          }, [
            _createElementVNode("header", _hoisted_12, [
              (mi === 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "drp-nav",
                    "aria-label": "Mois précédent",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.shiftMonth(-1)))
                  }, _cache[13] || (_cache[13] = [
                    _createElementVNode("i", {
                      class: "ph ph-caret-left",
                      "aria-hidden": "true"
                    }, null, -1)
                  ])))
                : (_openBlock(), _createElementBlock("span", _hoisted_13)),
              _createElementVNode("strong", null, _toDisplayString(month.title), 1),
              (mi === _ctx.months.length - 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    type: "button",
                    class: "drp-nav",
                    "aria-label": "Mois suivant",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.shiftMonth(1)))
                  }, _cache[14] || (_cache[14] = [
                    _createElementVNode("i", {
                      class: "ph ph-caret-right",
                      "aria-hidden": "true"
                    }, null, -1)
                  ])))
                : (_openBlock(), _createElementBlock("span", _hoisted_14))
            ]),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekdays, (d) => {
                return (_openBlock(), _createElementBlock("span", { key: d }, _toDisplayString(d), 1))
              }), 128))
            ]),
            _createElementVNode("div", {
              class: "drp-grid",
              onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hover = null))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(month.offset, (n) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: 'e' + n,
                  class: "drp-empty"
                }))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(month.days, (day) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: day.key,
                  type: "button",
                  class: _normalizeClass(["drp-day", _ctx.dayClass(day.date)]),
                  "aria-label": day.label,
                  "aria-pressed": _ctx.isEdge(day.date),
                  onClick: ($event: any) => (_ctx.pickDay(day.date)),
                  onMouseenter: ($event: any) => (_ctx.hover = day.date)
                }, _toDisplayString(day.date.getDate()), 43, _hoisted_16))
              }), 128))
            ], 32)
          ]))
        }), 128))
      ]),
      _createElementVNode("footer", _hoisted_17, [
        _createElementVNode("p", _hoisted_18, [
          (_ctx.draftStart)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("b", null, _toDisplayString(_ctx.fmtLong(_ctx.draftStart)), 1),
                (_ctx.draftEnd && !_ctx.sameDay(_ctx.draftStart, _ctx.draftEnd))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[15] || (_cache[15] = _createTextVNode(" → ", -1)),
                      _createElementVNode("b", null, _toDisplayString(_ctx.fmtLong(_ctx.draftEnd)), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.dayCount) + " jour" + _toDisplayString(_ctx.dayCount > 1 ? "s" : ""), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("Choisissez une date de début")
              ], 64))
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-light",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
          }, "Annuler"),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-primary",
            disabled: !_ctx.draftStart,
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.applyCustom && _ctx.applyCustom(...args)))
          }, " Appliquer ", 8, _hoisted_21)
        ])
      ])
    ])
  ], 32))
}